export default __webpack_public_path__ + "media/images/card-60bcd8bb4602637060c5e14847cae3c4.jpg";